import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";

const EXTRA_INFO_INDEXES = [0, 1, 2];

export default function ItemInfoModal({
    show,
    onHide,
    onSave,
    getCurrentItemText,
    info,
    handleInfoChange,
    extraInfo,
    handleExtraInfoKeyChange,
    handleExtraInfoValueChange,
    modalRef,
}) {
    return (
        <Modal show={show} onHide={onHide} size="lg" aria-labelledby="item-info-modal-title" centered>
            <Modal.Header closeButton>
                <Modal.Title id="item-info-modal-title">
                    Added Information for {getCurrentItemText()}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                        size="sm"
                        type="text"
                        placeholder="Description"
                        id="ItemDescription"
                        name="ItemDescription"
                        ref={modalRef}
                        onChange={handleInfoChange('Description')}
                        defaultValue={info.Description ?? ''}
                    />
                </Form.Group>

                <Form.Label>Extra (short text)</Form.Label>
                {EXTRA_INFO_INDEXES.map(i => (
                    <Row key={i} className="mb-2">
                        <Col>
                            <Form.Control
                                size="sm"
                                type="text"
                                placeholder="key"
                                id={`key${i}`}
                                onChange={handleExtraInfoKeyChange(i)}
                                defaultValue={extraInfo.find(x => x.index === i)?.key ?? ''}
                            />
                        </Col>
                        <Col>
                            <Form.Control
                                size="sm"
                                type="text"
                                placeholder="value"
                                id={`value${i}`}
                                onChange={handleExtraInfoValueChange(i)}
                                defaultValue={extraInfo.find(x => x.index === i)?.value ?? ''}
                            />
                        </Col>
                    </Row>
                ))}

                <Form.Group className="mb-3 mt-3">
                    <Form.Label>URL</Form.Label>
                    <Form.Control
                        size="sm"
                        type="text"
                        placeholder="url"
                        id="url"
                        name="url"
                        onChange={handleInfoChange('URL')}
                        defaultValue={info.URL ?? ''}
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>URL Text</Form.Label>
                    <Form.Control
                        size="sm"
                        type="text"
                        placeholder="url text"
                        id="urltext"
                        name="urltext"
                        onChange={handleInfoChange('URLText')}
                        defaultValue={info.URLText ?? ''}
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Maps link</Form.Label>
                    <Form.Control
                        size="sm"
                        type="text"
                        placeholder="link"
                        id="mapslink"
                        name="mapslink"
                        onChange={handleInfoChange('MapsLink')}
                        defaultValue={info.MapsLink ?? ''}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Close</Button>
                <Button variant="primary" onClick={onSave}>Save Changes</Button>
            </Modal.Footer>
        </Modal>
    );
}
